<div class="row">
  <app-headertext text="Admin - Kategorier"></app-headertext>
</div>

<div style="margin: 0 15px 0 15px;">
  <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
</div>

<div class="row child-margin">
  <div *ngIf="!mobileQuery.matches" class="fill-space"></div>
  <div class="maxwidth" style="width: 100%;">

    <!-- Add new Kategori -->
    <mat-card class="child-margin">
      <div class="row">
        <mat-form-field style="flex: 1;">
          <mat-label>Ny kategori</mat-label>
          <input matInput #newCat placeholder="f.eks. Elektro" (keyup.enter)="addCategory(newCat.value); newCat.value=''"/>
        </mat-form-field>
        <button mat-icon-button matTooltip="Legg til kategori" (click)="addCategory(newCat.value); newCat.value=''">
          <mat-icon color="primary">add</mat-icon>
        </button>
      </div>
    </mat-card>

    <mat-accordion multi="true">
      <!-- ============ KATEGORI ============ -->
      <mat-expansion-panel *ngFor="let category of categories">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <ng-container *ngIf="editingId !== category.id">
              <mat-icon style="margin-right: 8px;">category</mat-icon>
              {{ category.name }}
            </ng-container>
            <span *ngIf="editingId === category.id" (click)="$event.stopPropagation()">
              <mat-form-field>
                <input matInput #renameCat [value]="category.name" (keyup.enter)="renameCategory(category, renameCat.value)"/>
              </mat-form-field>
              <button mat-icon-button matTooltip="Lagre" (click)="renameCategory(category, renameCat.value)">
                <mat-icon>save</mat-icon>
              </button>
            </span>
          </mat-panel-title>
          <mat-panel-description>
            <span class="dimmed-60">{{ groupsFor(category.id).length }} grupper</span>
            <span class="fill-space"></span>
            <mat-icon class="cursor" matTooltip="Endre navn" (click)="$event.stopPropagation(); toggleEdit(category.id)">
              {{ editingId === category.id ? 'cancel' : 'edit' }}
            </mat-icon>
            <mat-icon class="cursor" color="warn" style="margin-left: 12px;" matTooltip="Slett kategori"
                      (click)="$event.stopPropagation(); deleteCategory(category)">delete</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <!-- Add new Gruppe -->
        <div class="row">
          <mat-form-field style="flex: 1;">
            <mat-label>Ny gruppe</mat-label>
            <input matInput #newGroup placeholder="f.eks. Skilt"
                   (keyup.enter)="addGroup(category.id, newGroup.value); newGroup.value=''"/>
          </mat-form-field>
          <button mat-icon-button matTooltip="Legg til gruppe" (click)="addGroup(category.id, newGroup.value); newGroup.value=''">
            <mat-icon color="primary">add</mat-icon>
          </button>
        </div>

        <!-- ============ GRUPPE ============ -->
        <mat-accordion multi="true">
          <mat-expansion-panel *ngFor="let group of groupsFor(category.id)" class="nested-panel">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <ng-container *ngIf="editingId !== group.id">
                  <mat-icon style="margin-right: 8px;">folder</mat-icon>
                  {{ group.name }}
                </ng-container>
                <span *ngIf="editingId === group.id" (click)="$event.stopPropagation()">
                  <mat-form-field>
                    <input matInput #editGroupInput [value]="group.name" (keyup.enter)="renameGroup(group, editGroupInput.value)"/>
                  </mat-form-field>
                  <button mat-icon-button matTooltip="Lagre" (click)="renameGroup(group, editGroupInput.value)">
                    <mat-icon>save</mat-icon>
                  </button>
                </span>
              </mat-panel-title>
              <mat-panel-description>
                <span class="dimmed-60">{{ subgroupsFor(group.id).length }} undergrupper</span>
                <span class="fill-space"></span>
                <mat-icon class="cursor" matTooltip="Endre navn" (click)="$event.stopPropagation(); toggleEdit(group.id)">
                  {{ editingId === group.id ? 'cancel' : 'edit' }}
                </mat-icon>
                <mat-icon class="cursor" color="warn" style="margin-left: 12px;" matTooltip="Slett gruppe"
                          (click)="$event.stopPropagation(); deleteGroup(group)">delete</mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <!-- Add new Undergruppe -->
            <div class="row">
              <mat-form-field style="flex: 1;">
                <mat-label>Ny undergruppe</mat-label>
                <input matInput #newSubgroup placeholder="f.eks. Variabelt fareskilt"
                       (keyup.enter)="addSubgroup(group.id, newSubgroup.value); newSubgroup.value=''"/>
              </mat-form-field>
              <button mat-icon-button matTooltip="Legg til undergruppe"
                      (click)="addSubgroup(group.id, newSubgroup.value); newSubgroup.value=''">
                <mat-icon color="primary">add</mat-icon>
              </button>
            </div>

            <!-- ============ UNDERGRUPPE ============ -->
            <div class="row subgroup-row" *ngFor="let subgroup of subgroupsFor(group.id)">
              <mat-icon style="margin-right: 8px;">label</mat-icon>
              <ng-container *ngIf="editingId !== subgroup.id">{{ subgroup.name }}</ng-container>
              <span *ngIf="editingId === subgroup.id">
                <mat-form-field>
                  <input matInput #editSubgroupInput [value]="subgroup.name"
                         (keyup.enter)="renameSubgroup(subgroup, editSubgroupInput.value)"/>
                </mat-form-field>
                <button mat-icon-button matTooltip="Lagre" (click)="renameSubgroup(subgroup, editSubgroupInput.value)">
                  <mat-icon>save</mat-icon>
                </button>
              </span>
              <span class="fill-space"></span>
              <mat-icon class="cursor" matTooltip="Endre navn" (click)="toggleEdit(subgroup.id)">
                {{ editingId === subgroup.id ? 'cancel' : 'edit' }}
              </mat-icon>
              <mat-icon class="cursor" color="warn" style="margin-left: 12px;" matTooltip="Slett undergruppe"
                        (click)="deleteSubgroup(subgroup)">delete</mat-icon>
            </div>
            <div class="dimmed-60" *ngIf="subgroupsFor(group.id).length === 0" style="padding: 8px 0;">
              Ingen undergrupper
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <div class="dimmed-60" *ngIf="groupsFor(category.id).length === 0" style="padding: 8px 0;">
          Ingen grupper
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <div class="dimmed-60" *ngIf="!isLoading && categories.length === 0" style="padding: 16px 0;">
      Ingen kategorier opprettet enda.
    </div>
  </div>
  <div *ngIf="!mobileQuery.matches" class="fill-space"></div>
</div>
